import { render, staticRenderFns } from "./SearchBlogList.vue?vue&type=template&id=eca7eab4&"
import script from "./SearchBlogList.vue?vue&type=script&lang=js&"
export * from "./SearchBlogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchItemPlaceHolder: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchItemPlaceHolder.vue').default,SearchProductCarousel: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchProductCarousel.vue').default})
